import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { TRANSLATION_KEYS } from '../../../../../../../../../../../translations'

import styles from './CurrentFQuarterWarning.module.scss'

interface ICurrentFQuarterWarningProps {
  isShown: boolean
  onClose: () => void
}

export const CurrentFQuarterWarning: FC<ICurrentFQuarterWarningProps> = ({ isShown, onClose }) => {
  return (
    <ModalDialog
      show={isShown}
      closeOnOutsideClick={false}
      classes={{
        overlay: styles.hideCrossIcon,
      }}
      content={(props) => {
        return (
          <div className={styles.modalContent}>
            <div className={styles.message}>
              <Translation text={TRANSLATION_KEYS.settings.periodCurrentFQuarterWarning} />
            </div>
            <div className={styles.actionButtons}>
              <Button onClick={props.onClose}>OK</Button>
            </div>
          </div>
        )
      }}
      contentProps={{
        onClose,
      }}
      size="xs"
      onClose={onClose}
    />
  )
}
